import { useContext, useState } from "react";
import { RootContext } from "../../../../../stores";
import { observer } from "mobx-react";
import RecordEditorDialog, { RecordEditorDialogProps } from "../RecordEditorDialog";
import ShiftEntry from "../../../../Organization/VolunteerOpportunities/ShiftEntry";
import { ShiftDetails } from "../../../../../stores/models/ShiftDetails";
import { useStandardStyles } from "../../../../../shared/general/hooks/useStandardStyles";
import { IOpportunity } from "../../../../../stores/models/Opportunity";

interface ShiftEntryDialogProps extends Omit<RecordEditorDialogProps<ShiftDetails>, 'children'> {

}

const ShiftEntryDialog = observer((props: ShiftEntryDialogProps) => {

    const rootStore = useContext(RootContext);
    const baseClasses = useStandardStyles();

    const [opportunity, setOpportunity] = useState<IOpportunity>();

    /********* API Requests *********/

    const loadOpportunity = async (opportunityId: number) => {
        const response = await rootStore.opportunityStore.getOpportunity(opportunityId);
        setOpportunity(response);
    }

    /********* Render *********/

    return (
        <RecordEditorDialog
            {...props}
            DialogContentProps={{ className: baseClasses.noPadding }}
        >
            {(record: ShiftDetails) =>
                <ShiftEntry
                    shift={record.shift}
                    locationOptions={rootStore.userStore.user.organization?.locations.addresses || []}
                    inlineLocationAdding
                    opportunityError={record.errors.opportunityId}
                    opportunityOptions={rootStore.userStore.user.organization?.roles}
                    onOpportunityChanged={(opportunityId: number) => {
                        record.setOpportunityId(opportunityId);
                        if (opportunityId !== opportunity?.id) {
                            loadOpportunity(opportunityId);
                        }
                    }}
                    opportunity={opportunity}
                />
            }
        </RecordEditorDialog>
    );
});

export default ShiftEntryDialog;